import React from 'react';
import { TimelineItem }  from 'vertical-timeline-component-for-react';
const AnEventDiv = () => {
    return (
        <TimelineItem dateText="30/04/2021" dateInnerStyle={{ background: '#61b8ff', color: '#000',textAlign:'center' }} bodyContainerStyle={{ background: 'whitesmoke', padding: '15px', borderRadius: '8px', boxShadow: "-1px 0px 15px 2px rgba(10,50,50,0.51)" }}>
            <h3 style={{ color: '#102772', fontWeight: '600' }}>Here will be a Title</h3>
            <h4 style={{ color: '#273c75',fontWeight: '400' }}>A Basic Subtitle on wish</h4>
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio deserunt ducimus rerum cum. Voluptates veniam corporis molestias tempore maiores dolor molestiae omnis eaque, velit quasi pariatur perferendis officiis est a!
            </p>
        </TimelineItem>
    );
};

export default AnEventDiv;